import AddIcon from "../../components/Icons/AddIcon";
import Button from "../../components/Shared/Button";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getCourses } from "../../api/Courses/GetAllCourses";
import Spinner from "../../components/Shared/Spinner";
import CourseCard from "../../components/Dashboard/Courses/CourseCard";
import AddCourse from "../../components/Dashboard/Courses/AddCourse";
import AddOfflineCourse from "../../components/Dashboard/Courses/AddOfflineCourse";
import { useUserDataStore } from "../../stores/user";
import { getCoursesOfflineAdmin } from "../../api/OfflineCourses/GetAllOfflineCoursesAdmin";
import { GetAllCoursesRevision } from "../../api/Courses/GetAllCoursesRevision";
import DashboardInlineBackButton from "../../components/Dashboard/Shared/DashboardInlineBackButton";
const Courses = () => {
  const [showAddCourse, setShowAddCourse] = useState(false);
  const [showAddOfflineCourse, setShowAddOfflineCourse] = useState(false);
  const { userData } = useUserDataStore();
  const { data: CoursesResponse, isLoading: isCoursesLoading } = useQuery({
    queryFn: getCourses,
    queryKey: ["courses"],
    staleTime: 0,
    refetchInterval: 0,
  });
  const {
    data: CoursesResponseRevision,
    isLoading: isCoursesRevisionLoading,
    refetch: refetchCoursesRevision,
  } = useQuery({
    queryFn: GetAllCoursesRevision,
    queryKey: ["coursesRevision"],
    staleTime: 0,
    refetchInterval: 0,
    enabled: userData.role !== "sales"
  });
  const { data: CoursesResponseOffline, isLoading: isCoursesOfflineLoading } =
    useQuery({
      queryFn: getCoursesOfflineAdmin,
      queryKey: ["offlineCourses"],
      staleTime: 0,
      refetchInterval: 0,
    });
  const coursesOffline = CoursesResponseOffline?.data?.coursesData || [];
  const courses = CoursesResponse?.data?.coursesData || [];
  const coursesRevision = CoursesResponseRevision?.data?.coursesData || [];

  const handleAddCourseSuccess = () => {
    setShowAddCourse(false);
  };

  const handleAddOfflineCourseSuccess = () => {
    setShowAddOfflineCourse(false);
  };

  if (isCoursesLoading || isCoursesOfflineLoading || isCoursesRevisionLoading)
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner />
      </div>
    );

  return (
    <div>
      {showAddCourse ? (
        <div className="space-y-4">
          <DashboardInlineBackButton
            label="Back to courses"
            onClick={() => setShowAddCourse(false)}
          />
          <AddCourse onSuccess={handleAddCourseSuccess} />
        </div>
      ) : showAddOfflineCourse ? (
        <div className="space-y-4">
          <DashboardInlineBackButton
            label="Back to courses"
            onClick={() => setShowAddOfflineCourse(false)}
          />
          <AddOfflineCourse onSuccess={handleAddOfflineCourseSuccess} />
        </div>
      ) : (
        <div>
          <div className="flex items-center justify-between py-7">
            <h1 className="text-burntBlack font-bold text-[32px]">My Course</h1>
            {userData?.role === "admin" && (
              <div className="flex gap-4 sm:flex-row flex-col">
                <Button
                  onClick={() => setShowAddCourse(true)}
                  className="!h-12 w-44 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                  variant="primary"
                >
                  <AddIcon />
                  Add New Course
                </Button>
                <Button
                  onClick={() => setShowAddOfflineCourse(true)}
                  className="!h-12 w-48 !text-sm font-bold rounded-md "
                  variant="primary"
                >
                  <AddIcon />
                  Add Offline Course
                </Button>
              </div>
            )}
          </div>
          <div className="grid grid-cols-1 gap-5 pb-40 sm:grid-cols-2 xl:grid-cols-3">
            {coursesRevision.map((course) => (
              <CourseCard
                key={course.id}
                course={course}
                refetchCoursesRevision={refetchCoursesRevision}
              />
            ))}
            {courses.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
            {coursesOffline.map((course) => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Courses;
